module.exports = __webpack_public_path__ + "static/media/share_sample.f002060d.jpg";